export const imageUrls = [
  { id: 0, src: '/img/canvasImages/0.svg' },
  { id: 1, src: '/img/canvasImages/1.svg' },
  { id: 2, src: '/img/canvasImages/2.svg' },
  { id: 3, src: '/img/canvasImages/3.svg' },
  { id: 4, src: '/img/canvasImages/4.svg' },
  { id: 5, src: '/img/canvasImages/5.svg' },
  { id: 6, src: '/img/canvasImages/6.svg' },
  { id: 7, src: '/img/canvasImages/7.svg' },
  { id: 8, src: '/img/canvasImages/8.svg' },
  { id: 9, src: '/img/canvasImages/9.svg' },
  { id: 10, src: '/img/canvasImages/10.svg' },
  { id: 11, src: '/img/canvasImages/11.svg' },
  { id: 12, src: '/img/canvasImages/12.svg' },
  { id: 13, src: '/img/canvasImages/13.svg' },
  { id: 14, src: '/img/canvasImages/14.svg' },
  { id: 15, src: '/img/canvasImages/15.svg' },
  { id: 16, src: '/img/canvasImages/16.svg' },
  { id: 17, src: '/img/canvasImages/17.svg' },
  { id: 18, src: '/img/canvasImages/18.svg' },
  { id: 19, src: '/img/canvasImages/19.svg' },
  { id: 20, src: '/img/canvasImages/20.svg' },
  { id: 21, src: '/img/canvasImages/21.svg' },
  { id: 22, src: '/img/canvasImages/22.svg' },
  { id: 23, src: '/img/canvasImages/23.svg' },
  { id: 24, src: '/img/canvasImages/24.svg' },
  { id: 25, src: '/img/canvasImages/25.svg' },
  { id: 26, src: '/img/canvasImages/26.svg' },
  { id: 27, src: '/img/canvasImages/27.svg' },
  { id: 28, src: '/img/canvasImages/28.svg' },
  { id: 29, src: '/img/canvasImages/29.svg' },
  { id: 30, src: '/img/canvasImages/30.svg' },
  { id: 31, src: '/img/canvasImages/31.svg' },
  { id: 32, src: '/img/canvasImages/32.svg' },
  { id: 33, src: '/img/canvasImages/33.svg' },
  { id: 34, src: '/img/canvasImages/34.svg' },
  { id: 35, src: '/img/canvasImages/35.svg' },
  { id: 36, src: '/img/canvasImages/36.svg' },
  { id: 37, src: '/img/canvasImages/37.svg' },
  { id: 38, src: '/img/canvasImages/38.svg' },
  { id: 39, src: '/img/canvasImages/39.svg' },
  { id: 40, src: '/img/canvasImages/40.svg' },
]
